<template>
    <div>
        <div class="pre-class-school-list__filter__action display-flex display-flex-space-between">
            <div class="wrap-left display-flex">
                <div class="item item__key input-custom-icon">
                    <input v-model.lazy="keyword" v-debounce="300" type="text" placeholder="Tìm kiếm bài"
                        class="primary-color-txt color_bg_gray_light border-rd-20 font-size-15 form-h30 border-0 full-width filter-keyword">
                    <i class="icon-search font-size-16 primary-color"></i>
                </div>
                <a href="javascript:;" @click="toggleCollapseGroup"
                    class="btn-collapse btn border-rd-20 font-size-15 filter-btn"
                    :class="{ 'btn-main': openCollapseFilterGroup, 'btn-main-light': !openCollapseFilterGroup }">
                    Bộ lọc <i class="icon-arrow-down font-size-12"
                        :class="{ 'color-light': openCollapseFilterGroup, 'primary-color': !openCollapseFilterGroup }"></i>
                </a>
            </div>
        </div>
        <b-collapse id="collapse_filter" class="mt-2" :visible="openCollapseFilterGroup">
            <div>
                <div class="filter__section">
                    <div class="row col-md-12">
                        <div class="col-md-4">
                            <b-form-select v-model="classId" :options="listDataClass">
                                <!-- <option value=0>Tất cả</option> -->
                            </b-form-select>
                        </div>
                        <div class="col-md-4">
                            <b-form-select v-model="subjectId" :options="listDataSubject">
                                <!-- <option value=0>Tất cả</option> -->
                            </b-form-select>
                        </div>
                        <div class="col-md-4" v-if="isShowFilterTypeExcercise">
                            <b-form-select v-model="typeExcercise" :options="listExcercise">
                                <!-- <option value=0>Tất cả</option> -->
                            </b-form-select>
                        </div>
                    </div>
                </div>
            </div>
        </b-collapse>
    </div>

</template>
<script>
import { getAllTypeFilter, getAllClassFilter } from './../../../_api/'
import debounce from "@/directives/debounce";
export default {
    directives: { debounce },
    watch: {
        'classId': 'handleChangeClassId',
        'keyword': 'handleSeach',
        'subjectId': 'handleChangeSubjectId',
        'typeExcercise': 'handleChangeTypeExcercise'
    },
    data() {
        return {
            openCollapseFilterGroup: false,
            listDataSubject: [{ value: 0, text: "Môn học - Tất cả" },],
            listDataClass: [{ value: 0, text: "Khối - Tất cả" },],
            listExcercise: [
                { text: 'Loại đề - Tất cả', value: 0 },
                { text: 'Bài kiểm tra', value: 1 },
                { text: 'Bài tập', value: 2 },],
            subjectId: 0,
            classId: 0,
            typeExcercise: 0,
            keyword: '',
        }
    },
    props: {
        isShowFilterTypeExcercise: {
            type: Boolean,
            default: true
        }
    },
    mounted() {
        this.GetAllClass()
    },
    methods: {
        handleSeach() {

            this.handleOnFilter()
        },
        handleChangeSubjectId(e) {
            this.handleOnFilter()
        },
        handleChangeTypeExcercise() {
            this.handleOnFilter()
        },
        handleChangeClassId(e) {
            this.handleOnFilter()
            this.getTypesFilter()
        },
        toggleCollapseGroup() {
            this.openCollapseFilterGroup = !this.openCollapseFilterGroup

        },
        handleOnFilter() {
            let filter = {
                keyword: this.keyword,
                subjectId: this.subjectId,
                classId: this.classId,
                typeExcercise: this.typeExcercise
            }
            console.log(filter)
            this.$emit('handleSeach', filter)
        },
        getTypesFilter() {
            let self = this
            self.listDataSubject = [{ value: 0, text: "Tất cả" },]
            this.subjectId = 0
            getAllTypeFilter({ classId: this.classId }).then(res => {
                if (res && res.data && !res.errors) {
                    for (let i = 0; i < res.data.ltsSubject.length; i++) {
                        const item = res.data.ltsSubject[i];
                        self.listDataSubject.push({ value: item.subjectId, text: item.name })
                    }
                }
            })
        },
        GetAllClass() {
            let self = this
            getAllClassFilter({}).then(res => {
                if (res && res.data && !res.errors) {
                    for (let i = 0; i < res.data.length; i++) {
                        const item = res.data[i];
                        self.listDataClass.push({ value: item.classId, text: item.name })
                    }
                }
            })
        }
    }
}
</script>


<style lang="scss" scoped>
.text-align-right {
    text-align: right;
}

.filter-keyword {
    padding-right: 30px !important;
}

.filter-btn {
    margin-left: 20px;
}

.filter__section__form {
    margin-top: 20px;

    .margin-left-10 {
        margin-left: 10px;
    }

    .min-width-100 {
        min-width: 100px;
    }
}

.filter_option_menu {
    flex-wrap: wrap;

    >* {
        //width: 33.33%;
    }
}
</style>